<template>
  <div style="width: 100%;">
    <el-date-picker @change="getAssemblyEachUnitNumData" v-model="fromData.day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                    placeholder="选择月份" :clearable="false"/>
    <div class="divSize" v-loading="assemblyEachLoading" element-loading-text="数据加载中"
         style="width: 100%;min-height: 300px;" id="assemblyEach"/>
    <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center', width: '100%',}"  :data="tableData" border style="width: 100%;height:78%;margin-top: 10px">
      <el-table-column v-for="item in tableNameList" :key="item" :prop="item" :label="item" min-width="120"/>
    </el-table>
  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgAssemblyEachUnitNum",
  data() {
    return {
      fromData: {
        day:this.getDateFormat(),
      },
      tableData:[],
      tableNameList:[],
      assemblyEachPlanTableList:[],
      assemblyEachTableList:[],
      differenceTableList:[],
      rateTableList:[],
      //出货进度
      assemblyEach: {
        title: [
          {
            text: this.$t('makeSchedule.assemblyEachUnitNumPage.productionSchedule'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {bottom: '0',},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            barWidth: '50px',
            name: this.$t('makeSchedule.assemblyEachUnitNumPage.plan'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '(套)';
              }
            },
            data: []
          },
          {
            barWidth: '50px',
            name: this.$t('makeSchedule.assemblyEachUnitNumPage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '(套)';
              }
            },
            data: []
          },
        ]
      },
      assemblyEachLoading: false,
    }
  },methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    async getAssemblyEachUnitNumData() {
      if (!this.fromData.day) {
        this.fromData.day = this.getDateFormat()
      }
      this.assemblyEachLoading = true
      let {data: res} = await this.$axios.post('mfg/shipmentSchedule/getAssemblyEachUnitNumData', this.fromData);
      this.assemblyEachLoading = false
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }

      console.log("111111111111",res.data)
      this.tableNameList = res.data.tableNameList
      this.tableData = res.data.tableData
      this.assemblyEach.xAxis[0].data = res.data.xAxis
      this.assemblyEach.series[0].data = res.data.assemblyEachPlanList
      this.assemblyEach.series[1].data = res.data.assemblyEachList
      let a = this.$common.getDivisor(Math.max(...res.data.assemblyEachList))
      let b = this.$common.getDivisor(Math.max(...res.data.assemblyEachPlanList))
      let c = 0;let d = 0;
      for (let item of res.data.assemblyEachList) {
        if (c < item) {
          c = item;
        }
      }
      for (let item of res.data.assemblyEachPlanList) {
        if (d < item) {
          d = item;
        }
      }
      if (c > d) {
        c = res.data.assemblyEachList;
        d = a
      } else {
        c = res.data.assemblyEachPlanList;
        d = b
      }
      this.assemblyEach.yAxis[0].max = Math.ceil(Math.max(...c) / d) * d
      this.assemblyEach.yAxis[0].interval = Math.round(this.assemblyEach.yAxis[0].max / 5 * 100) / 100
      this.renderEcharts('assemblyEach', this.assemblyEach)
    }
  },created() {
    this.getAssemblyEachUnitNumData();
  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>